import React, { useState, useEffect } from "react";
import calanderIcon from "../../../../assets/images/budget/calander.png";
import filterIcon from "../../../../assets/images/budget/filter.png";
import editIcon from "../../../../assets/images/budget/dropdown.png";
import menuIcon from "../../../../assets/images/DeathModuleNew/Menu.png";
import "./AddBudget.css";
import { BudgetModal } from "../Modals/BudgetModal";
import DEATH_API from "../../../../apis/death.api";
import { Select, Menu, Dropdown, Progress, Modal, TreeSelect } from "antd";
import swal from "sweetalert";
import Tab, { TabItem } from "./components/budgetTabs/Tabs";
import Loader from "../../../../components/styled-components/loader/loader";
import NewLoader from "../../../../components/styled-components/loader/NewLoader";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { CategorizedBudget } from "./components/categoryBudget/CategorizedBudget";
import { SetBudget } from "./components/setBudget/SetBudget";
import BUDGET_API from "../../../../apis/budget.api";
const { TreeNode } = TreeSelect;
const { Option, OptGroup } = Select;

export const AddBudget = () => {
  const [selectedFilter, setSelectedFilter] = useState(null);
  const history = useHistory();
  const [addModal, setAddModal] = useState(false);
  const [categoryModal, setCategoryModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [formData, setFormData] = useState(null);
  const [categories, setCategories] = useState(null);
  const [chartData, setChartData] = useState(null);
  const [budgetData, setBudgetData] = useState(null);
  const [monthsBudgetData, setMonthsBudgetData] = useState(null);
  const [transactions, setTransactions] = useState(null);
  const [categoryBudget, setCategoryBudget] = useState(null);
  const [categoryArray, setCategoryArray] = useState(null);
  const [uncategorisedUsed, setUnCategorisedUsed] = useState(null);
  const [notYetBudgetedData, setNotYetBudgetedData] = useState(null);
  const [notYetBudgetedSubcategoryData, setNotYetBudgetedSubcategoryData] =
    useState([]);

  const [selectedDataNotBudgeted, setSelectedDataNotBudgeted] = useState(null);

  const [loading, setLoading] = useState(false);
  const [filterData, setFilterData] = useState(null);
  const [clientTransactionsCategories, setClientTransactionsCategories] =
    useState(null);
  const [clientTransactionsSubCategories, setClientTransactionsSubCategories] =
    useState(null);

  const [selectedIndex, setSelectedIndex] = useState(0);
  const financialAccess =
    localStorage.getItem("financialAccess") != "undefined" &&
    JSON.parse(localStorage.getItem("financialAccess") || null);
  const onTabSelected = (index) => {
    setSelectedIndex(index);
  };
  const handleCancelCategory = () => {
    setCategoryModal(false);
    setFormData(null);
    setSelectedData(null);
    setSelectedDataNotBudgeted(null);
  };
  const handleSaveCategory = async () => {
    console.log(formData);
    setCategoryModal(false);
    let payload = {};
    if (formData && formData.categoryName) {
      payload = {
        ...formData,
      };
    } else {
      payload = {
        categoryName: formData.subCategoryName,
      };
    }
    try {
      setLoading(true);
      let data = await DEATH_API.createCategory(payload);
      if (data && data.status === 200) {
        swal("Success", data.message, "success");
        await getCategories("false");
      }
      if (data && data.status === 400) {
        swal("Error", data.message, "error");
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
    setFormData(null);
    setSelectedData(null);
    setSelectedDataNotBudgeted(null);
  };
  const getCategories = async () => {
    try {
      setLoading(true);
      let data = await DEATH_API.getCategories("false");
      if (data && data.status === 200 && data.data) {
        const filteredCategories = data.data
          .filter(
            (category) =>
              category.categoryName !== "Transfer Out" &&
              category.categoryName !== "Credit Card Payment"
          )
          .map((category) => ({
            ...category,
            subCategories: category.subCategories.filter(
              (sub) => sub.name !== "Credit Card Payment"
            ),
          })); // Keep categories with valid subcategories
        setCategories(filteredCategories);
        // setCategories(data.data);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getChartData = async (payloadData) => {
    try {
      setLoading(true);
      let payload = {
        categoryId:
          payloadData && payloadData.categoryId ? payloadData.categoryId : [],
        subCategoryId:
          payloadData && payloadData.subCategoryId
            ? payloadData.subCategoryId
            : [],
      };
      let data = await DEATH_API.getBudgetChartData(payload);
      if (data && data) {
        setChartData(data);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const getChartDataForLast12Months = async (payloadData) => {
    try {
      setLoading(true);
      const dateRanges = Array.from({ length: 12 }, (_, i) => {
        const startDate = moment()
          .subtract(i, "months")
          .startOf("month")
          .format("YYYY-MM-DD");
        const endDate = moment()
          .subtract(i, "months")
          .endOf("month")
          .format("YYYY-MM-DD");
        return { startDate, endDate };
      });
      const categoryIds =
        clientTransactionsCategories &&
        clientTransactionsCategories
          .filter((item) => item.enable === true)
          .map((item) => item.categoryId);
      const subCategoryIds =
        clientTransactionsSubCategories &&
        clientTransactionsSubCategories
          .filter((item) => item.enable === true)
          .map((item) => item.subCategoryId);
      let payload = {
        categoryId:
          payloadData && payloadData.categoryIds
            ? payloadData.categoryIds
            : (categoryIds && categoryIds) || [],
        subCategoryId:
          payloadData && payloadData.subCategoryIds
            ? payloadData.subCategoryIds
            : (subCategoryIds && subCategoryIds) || [],
      };

      const apiCalls = dateRanges.map(({ startDate, endDate }) =>
        DEATH_API.getBudgetChartDataMonthly(startDate, endDate, {
          ...payload,
          startDate,
          endDate,
        })
          .then((data) => ({ startDate, endDate, data })) // Add metadata to the result
          .catch((error) => {
            console.log(
              `Error fetching data for ${startDate} to ${endDate}:`,
              error
            );
            return { startDate, endDate, data: null }; // Return null for failed calls
          })
      );

      const chartDataArray = await Promise.all(apiCalls);
      const filteredData = chartDataArray.filter((entry) => entry.data);
      const validData = chartDataArray
        .filter((entry) => entry.data && entry.data) // Filter successful responses
        .map((entry) => entry.data);
      console.log("chartDataArray", validData);
      if (validData) {
        setChartData(validData);
      }
      setLoading(false);
    } catch (error) {
      console.log("Error fetching chart data:", error);
      setLoading(false);
    }
  };

  const updateChartCategories = async (dataToUpdate) => {
    console.log("dataToUpdate", dataToUpdate);
    await updateTransactionsCategories();
    await updateTransactionsSubCategories();
  };
  const getTransactionsCategoriesByFilter = async (startDate, endDate) => {
    try {
      setLoading(true);
      const filteredCategories =
        clientTransactionsCategories &&
        clientTransactionsCategories.filter(
          (item) =>
            item.category.categoryName !== "Transfer Out" &&
            item.category.categoryName !== "Credit Card Payment"
        );
      const promises =
        filteredCategories &&
        filteredCategories.map((budget) => {
          const payload = {
            startDate,
            endDate,
            category: budget.categoryId,
            subCategory: budget.subCategoryId && budget.subCategoryId,
          };
          return BUDGET_API.getCalculatedBudgetTransactions(payload).then(
            (response) => ({
              budget,
              response,
            })
          );
        });
      const results = await Promise.all(promises);
      console.log("results from not are", results);
      const structuredData = results
        .filter(
          ({ response }) =>
            response &&
            response.currentMonthTransactions &&
            response.currentMonthTransactions.totalAmount &&
            response.currentMonthTransactions.totalAmount
        )
        .map(({ budget, response }) => {
          const amount = response.currentMonthTransactions.totalAmount || 0;

          return {
            categoryId: budget && budget.categoryId && budget.categoryId,
            categoryName:
              (budget && budget.category && budget.category.categoryName) || "",
            subCategory:
              (budget && budget.subCategory && budget.subCategory.name) || null,
            subCategoryId:
              (budget && budget.subCategoryId && budget.subCategoryId) || null,
            amount: Math.abs(amount),
          };
        });
      console.log("results from not", structuredData);
      if (structuredData) {
        setNotYetBudgetedData(structuredData);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getTransactionsSubCategoriesByFilter = async (startDate, endDate) => {
    try {
      setLoading(true);
      const filteredSubCategories =
        clientTransactionsSubCategories &&
        clientTransactionsSubCategories.filter(
          (item) =>
            item.subCategoryCategory.categoryName !== "Transfer Out" &&
            item.subCategoryCategory.categoryName !== "Credit Card Payment" &&
            item.subCategory.name !== "Credit Card Payment"
        );
      // setClientTransactionsSubCategories(filteredSubCategories);
      const promises =
        filteredSubCategories &&
        filteredSubCategories.map((subCategory) => {
          const payload = {
            startDate,
            endDate,
            category: subCategory.categoryId,
            subCategory: subCategory.subCategoryId,
          };
          return BUDGET_API.getCalculatedBudgetTransactions(payload).then(
            (response) => ({
              subCategory,
              response,
            })
          );
        });
      const results = await Promise.all(promises);
      const structuredData = results
        .filter(
          ({ response }) =>
            response &&
            response.currentMonthTransactions &&
            response.currentMonthTransactions.totalAmount &&
            response.currentMonthTransactions.totalAmount
        )
        .map(({ subCategory: budget, response }) => {
          const amount = response.currentMonthTransactions.totalAmount || 0;

          return {
            categoryId: budget && budget.categoryId && budget.categoryId,
            categoryName:
              (budget &&
                budget.subCategoryCategory &&
                budget.subCategoryCategory.categoryName) ||
              "",
            subCategory:
              (budget && budget.subCategory && budget.subCategory.name) || null,
            subCategoryId:
              (budget && budget.subCategoryId && budget.subCategoryId) || null,
            amount: Math.abs(amount),
          };
        });
      console.log("results from not", structuredData);
      if (structuredData) {
        setNotYetBudgetedSubcategoryData(structuredData);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const getTransactionsCategories = async () => {
    try {
      setLoading(true);
      const date = moment();
      const startDate = date.startOf("month").format("YYYY-MM-DD"); // Start of the month
      const endDate = date.endOf("month").format("YYYY-MM-DD");
      let data = await BUDGET_API.fetchAllTransactionCatgoires();
      if (data && data.status === 200) {
        let categoryIds =
          data.data &&
          data.data
            .filter(
              (item) =>
                item.enable === true &&
                item.category.categoryName !== "Transfer Out" &&
                item.category.categoryName !== "Credit Card Payment"
            )
            .map((item) => item.categoryId);
        const filteredCategories =
          data.data &&
          data.data.filter(
            (item) =>
              item.category.categoryName !== "Transfer Out" &&
              item.category.categoryName !== "Credit Card Payment"
          );
        setClientTransactionsCategories(filteredCategories);

        const promises =
          filteredCategories &&
          filteredCategories.map((budget) => {
            const payload = {
              startDate,
              endDate,
              category: budget.categoryId,
              subCategory: budget.subCategoryId && budget.subCategoryId,
            };
            return BUDGET_API.getCalculatedBudgetTransactions(payload).then(
              (response) => ({
                budget,
                response,
              })
            );
          });
        const results = await Promise.all(promises);
        // console.log("results from not",results)

        // const structuredData = results.map(({ budget, response }) => {
        //   const amount = response.currentMonthTransactions.totalAmount || 0;

        //   return {
        //     categoryId: budget && budget.categoryId && budget.categoryId,
        //     categoryName: budget && budget.category && budget.category.categoryName || "",
        //     subCategory: budget && budget.subCategory && budget.subCategory.name || null,
        //     subCategoryId: budget && budget.subCategoryId && budget.subCategoryId || null,
        //     amount:Math.abs(amount),
        //   };
        // });
        const structuredData = results
          .filter(
            ({ response }) =>
              response &&
              response.currentMonthTransactions &&
              response.currentMonthTransactions.totalAmount &&
              response.currentMonthTransactions.totalAmount
          )
          .map(({ budget, response }) => {
            const amount = response.currentMonthTransactions.totalAmount || 0;

            return {
              categoryId: budget && budget.categoryId && budget.categoryId,
              categoryName:
                (budget && budget.category && budget.category.categoryName) ||
                "",
              subCategory:
                (budget && budget.subCategory && budget.subCategory.name) ||
                null,
              subCategoryId:
                (budget && budget.subCategoryId && budget.subCategoryId) ||
                null,
              amount: Math.abs(amount),
            };
          });
        console.log("results from not", structuredData);
        if (structuredData) {
          setNotYetBudgetedData(structuredData);
        }
        return categoryIds;
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getTransactionsSubCategories = async () => {
    try {
      setLoading(true);
      let data = await BUDGET_API.fetchAllTransactionSubCatgoires();
      if (data && data.status === 200) {
        let categoryIds =
          data.data &&
          data.data
            .filter(
              (item) =>
                item.enable === true &&
                item.subCategoryCategory.categoryName !== "Transfer Out" &&
                item.subCategoryCategory.categoryName !==
                  "Credit Card Payment" &&
                item.subCategory.name !== "Credit Card Payment"
            )
            .map((item) => item.subCategoryId);
        const filteredSubCategories =
          data.data &&
          data.data.filter(
            (item) =>
              item.subCategoryCategory.categoryName !== "Transfer Out" &&
              item.subCategoryCategory.categoryName !== "Credit Card Payment" &&
              item.subCategory.name !== "Credit Card Payment"
          );
        setClientTransactionsSubCategories(filteredSubCategories);
        const date = moment();
        const startDate = date.startOf("month").format("YYYY-MM-DD"); // Start of the month
        const endDate = date.endOf("month").format("YYYY-MM-DD");
        const promises =
          filteredSubCategories &&
          filteredSubCategories.map((subCategory) => {
            const payload = {
              startDate,
              endDate,
              category: subCategory.categoryId,
              subCategory: subCategory.subCategoryId,
            };
            return BUDGET_API.getCalculatedBudgetTransactions(payload).then(
              (response) => ({
                subCategory,
                response,
              })
            );
          });
        const results = await Promise.all(promises);
        const structuredData = results
          .filter(
            ({ response }) =>
              response &&
              response.currentMonthTransactions &&
              response.currentMonthTransactions.totalAmount &&
              response.currentMonthTransactions.totalAmount
          )
          .map(({ subCategory: budget, response }) => {
            const amount = response.currentMonthTransactions.totalAmount || 0;

            return {
              categoryId: budget && budget.categoryId && budget.categoryId,
              categoryName:
                (budget &&
                  budget.subCategoryCategory &&
                  budget.subCategoryCategory.categoryName) ||
                "",
              subCategory:
                (budget && budget.subCategory && budget.subCategory.name) ||
                null,
              subCategoryId:
                (budget && budget.subCategoryId && budget.subCategoryId) ||
                null,
              amount: Math.abs(amount),
            };
          });
        console.log("results from not", structuredData);
        if (structuredData) {
          setNotYetBudgetedSubcategoryData(structuredData);
        }
        return categoryIds;
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const updateTransactionsCategories = async (payloadData) => {
    try {
      setLoading(true);
      let data = await BUDGET_API.updateAllTransactionCategoires(payloadData);
      if (data && data.status === 200) {
        await getTransactionsCategories();
        let categoryIds = await getTransactionsCategories();
        let payload = {
          categoryIds,
        };
        await getChartDataForLast12Months(payload);
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const updateTransactionsSubCategories = async (payloadData) => {
    try {
      setLoading(true);
      let data = await BUDGET_API.updateAllTransactionSubCategoires(
        payloadData
      );
      if (data && data.status === 200) {
        let subCategoryIds = await getTransactionsSubCategories();
        let payload = {
          subCategoryIds,
        };
        await getChartDataForLast12Months(payload);
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const getBudget = async () => {
    try {
      setLoading(true);
      let data = await DEATH_API.getBudget();
      if (data && data.status === 200 && data.categorized) {
        setBudgetData(data.categorized);
        let categoryIds =
          data.categorized && data.categorized.map((item) => item.categoryId);
        console.log("categoryIds", categoryIds);
        setCategoryArray(categoryIds);
      }

      if (data && data.uncategorized) {
        console.log("data.uncategorized", data.uncategorized);
      }
      await getCalculatedBudget();
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const getAllFilterBudgets = async (startDate, endDate) => {
    try {
      setLoading(true);
      let data = await BUDGET_API.fetchAllBudget(startDate, endDate, "all","false");
      if (data && data.status === 200 && data.categorized) {
        setBudgetData(data.categorized);
        const promises =
          data.categorized &&
          data.categorized.map((budget) => {
            const payload = {
              startDate,
              endDate,
              category: budget.categoryId, // Send categoryId for this budget
              subCategory: budget.subCategoryId,
            };
            return BUDGET_API.getCalculatedBudgetTransactions(payload).then(
              (response) => ({
                budget, // Include the original budget
                response, // Include the calculated response
              })
            );
          });

        const results = await Promise.all(promises);

        // Transform results into the desired structure
        const structuredData = results.map(({ budget, response }) => {
          const usedAmount =
            (response.currentMonthTransactions.totalAmount &&
              Math.abs(response.currentMonthTransactions.totalAmount)) ||
            0;
          const totalAmount = budget.amount || 0;
          const leftAmount = totalAmount - usedAmount;

          return {
            categoryId: budget && budget.categoryId && budget.categoryId,
            categoryName:
              (budget.budgetCategory && budget.budgetCategory.categoryName) ||
              "",
            subCategoryId:
              (budget && budget.subCategoryId && budget.subCategoryId) || null,
            usedAmount,
            leftAmount,
            totalAmount,
            image: (budget.budgetCategory && budget.budgetCategory.image) || "", // Assuming `image` exists in `budgetCategory`
          };
        });
        // Log or set the structured data in state
        console.log("Structured Data:", structuredData);
        if (structuredData) {
          setCategoryBudget(structuredData);
        }
      }
      // await getCalculatedBudget();
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getAllFilterBudgetsMonthsCategory = async (startDate, endDate) => {
    try {
      setLoading(true);
      let data = await BUDGET_API.fetchAllBudget(startDate, endDate, "month","false");
      if (data && data.status === 200 && data.categorized) {
        setMonthsBudgetData(data.categorized);
        let payload = {
          startDate,
          endDate,
        };
        getCalculatedBudgetTransactionsUncategorized(payload);
      }
      // await getCalculatedBudget();
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getAllBudgets = async () => {
    try {
      setLoading(true);
      const date = moment();
      const startDate = date.startOf("month").format("YYYY-MM-DD"); // Start of the month
      const endDate = date.endOf("month").format("YYYY-MM-DD");
      let data = await BUDGET_API.fetchAllBudget(startDate, endDate, "all","false");
      if (data && data.status === 200 && data.categorized) {
        setBudgetData(data.categorized);
        const promises =
          data.categorized &&
          data.categorized.map((budget) => {
            const payload = {
              startDate,
              endDate,
              category: budget.categoryId, // Send categoryId for this budget
              subCategory: budget.subCategoryId,
            };
            return BUDGET_API.getCalculatedBudgetTransactions(payload).then(
              (response) => ({
                budget, // Include the original budget
                response, // Include the calculated response
              })
            );
          });

        const results = await Promise.all(promises);

        // Transform results into the desired structure
        const structuredData = results.map(({ budget, response }) => {
          const usedAmount =
            (response.currentMonthTransactions.totalAmount &&
              Math.abs(response.currentMonthTransactions.totalAmount)) ||
            0;
          const totalAmount = budget.amount || 0;
          const leftAmount = totalAmount - usedAmount;

          return {
            categoryId: budget && budget.categoryId && budget.categoryId,
            categoryName:
              (budget.budgetCategory && budget.budgetCategory.categoryName) ||
              "",
            subCategoryId:
              (budget && budget.subCategoryId && budget.subCategoryId) || null,
            usedAmount,
            leftAmount,
            totalAmount,
            image: (budget.budgetCategory && budget.budgetCategory.image) || "", // Assuming `image` exists in `budgetCategory`
          };
        });
        // Log or set the structured data in state
        console.log("Structured Data:", structuredData);
        if (structuredData) {
          setCategoryBudget(structuredData);
        }
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getAllBudgetsUncategorized = async () => {
    try {
      setLoading(true);
      const date = moment();
      const startDate = date.startOf("month").format("YYYY-MM-DD"); // Start of the month
      const endDate = date.endOf("month").format("YYYY-MM-DD");
      let data = await BUDGET_API.fetchAllBudget(startDate, endDate, null,"false");
      if (data && data.status === 200 && data.categorized) {
        // setBudgetData(data.categorized);
      }
      // await getCalculatedBudget();
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getAllBudgetsMonthsCategory = async () => {
    try {
      setLoading(true);
      const date = moment();
      const startDate = date.startOf("month").format("YYYY-MM-DD"); // Start of the month
      const endDate = date.endOf("month").format("YYYY-MM-DD");
      let data = await BUDGET_API.fetchAllBudget(startDate, endDate, "month","false");
      if (data && data.status === 200 && data.categorized) {
        // setBudgetData(data.categorized);
        setMonthsBudgetData(data.categorized);
        let payload = { startDate, endDate };
        await getCalculatedBudgetTransactionsUncategorized(payload);
      }
      // await getCalculatedBudget();
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getCalculatedBudget = async () => {
    try {
      setLoading(true);
      let data = await DEATH_API.getCalculatedBudget();
      if (data && data.status === 200 && data.budgets) {
        console.log("data calculted", data.budgets);
        setCategoryBudget(data.budgets);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getCalculatedBudgetTransactions = async (payload) => {
    try {
      setLoading(true);
      let data = await BUDGET_API.getCalculatedBudgetTransactions(payload);
      if (data && data.status === 200) {
        console.log("data", data.data);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getCalculatedBudgetTransactionsUncategorized = async (payload) => {
    try {
      setLoading(true);
      let data = await BUDGET_API.getCalculatedBudgetTransactions(payload);
      if (data && data.status === 200) {
        console.log(
          "data uncategorised",
          data.currentMonthTransactions.totalAmount
        );
        setUnCategorisedUsed(data.currentMonthTransactions.totalAmount);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const handleCancelAddModal = () => {
    setAddModal(false);
    setFormData(null);
    setSelectedData(null);
    setSelectedDataNotBudgeted(null);
  };
  const handleSaveAddModal = async () => {
    console.log(formData);
    setAddModal(false);
    let categoryId = null;
    let subcategoryId = null;
    console.log("categoryId", formData, categories);
    if (selectedData && selectedDataNotBudgeted === null) {
      let payload = {
        ...formData,
        amount: formData.amount,
      };
      if (formData && formData.categoryName && !formData.categoryId) {
        const category =
          categories &&
          categories.find(
            (item) => item.categoryName === formData.categoryName
          );
        categoryId = category && category.id;
        console.log("category22", category, categoryId);
        payload.categoryId = categoryId;
      }
      // if (formData && formData.categoryName) {
      //   const category = categories && categories.find((item) => item.categoryName === formData.categoryName);
      //   console.log("category",category)
      //   if (!category) {
      //     categories && categories.forEach((item) => {
      //       const subcategory = item.subCategories && item.subCategories.find((sub) => sub.name === formData.categoryName);
      //       if (subcategory) {
      //         categoryId = item.id;
      //         subcategoryId = subcategory.id;
      //       }
      //     });
      //   } else {
      //     categoryId = category.id;
      //     const subcategory = category.subCategories && category.subCategories.find((sub) => sub.name === formData.categoryName);
      //     if (subcategory){
      //       subcategoryId = subcategory.id;
      //     }
      //   }
      // }
      try {
        setLoading(true);
        let data = await DEATH_API.updateBudget(selectedData.id, payload);
        if (data && data.status === 200) {
          swal("Success", data.message, "success");
          await getAllBudgets();
          await getTransactionsSubCategories();
          // await getBudget();
        }
        if (data && data.status === 400) {
          swal("Error", data.message, "error");
        }
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    } else {
      let payload = {
        ...formData,
        amount: formData.amount,
        divorceBudgetAmount: formData.amount,
      };
      if (formData && formData.categoryName && !formData.categoryId) {
        const category =
          categories &&
          categories.find(
            (item) => item.categoryName === formData.categoryName
          );
        categoryId = category && category.id;
        // categoryId =
        //   categories &&
        //   categories.find((item) => item.categoryName === formData.categoryName)
        //     .id;
        payload.categoryId = categoryId;
      }
      // if (formData && formData.categoryName) {
      //   const category = categories && categories.find((item) => item.categoryName === formData.categoryName);
      //   console.log("category",category)
      //   if (!category) {
      //     categories && categories.forEach((item) => {
      //       const subcategory = item.subCategories && item.subCategories.find((sub) => sub.name === formData.categoryName);
      //       if (subcategory) {
      //         categoryId = item.id;
      //         subcategoryId = subcategory.id;
      //       }
      //     });
      //   } else {
      //     categoryId = category.id;
      //     const subcategory = category.subCategories && category.subCategories.find((sub) => sub.name === formData.categoryName);
      //     if (subcategory){
      //       subcategoryId = subcategory.id;
      //     }
      //   }
      // }
      try {
        setLoading(true);
        let data = await DEATH_API.createBudget(payload);
        if (data && data.status === 200) {
          swal("Success", data.message, "success");
          await getAllBudgets();
          await getTransactionsSubCategories();
          // await getBudget();
        }
        if (data && data.status === 400) {
          swal("Error", data.message, "error");
        }
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    }

    setFormData(null);
    setSelectedData(null);
    setSelectedDataNotBudgeted(null);
  };
  const deleteSelectBudget = async (id) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this budget?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, Delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          await DEATH_API.deleteBudget(id);
          setLoading(false);
          await getAllBudgets();
          await getTransactionsSubCategories();
          // await getBudget();
          setLoading(false);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
        setTimeout(async () => {
          swal("Deleted!", "Your Budget has been deleted.", "success");
        }, 0);
      } else {
        swal("Cancelled", "Your Budget is safe :)", "error");
      }
    });
  };
  const getTransactions = async () => {
    try {
      setLoading(true);
      let data = await DEATH_API.getBudgetTransaction();
      if (data && data.data) {
        console.log("categoryNamesToSkip", categories);
        const categoryNamesToSkip =
          (categories && categories.map((category) => category.categoryName)) ||
          [];
        const transactionsByCategory = data.data.reduce((accumulator, item) => {
          const { categoryFromPlaid, amount, subCategory, date } = item;
          const transactionDate = new Date(date);
          const currentDate = new Date();
          const isCurrentMonth =
            transactionDate.getMonth() === currentDate.getMonth() &&
            transactionDate.getFullYear() === currentDate.getFullYear();

          if (
            isCurrentMonth &&
            categoryFromPlaid &&
            amount &&
            !categoryNamesToSkip.includes(categoryFromPlaid)
          ) {
            const key = subCategory
              ? `${categoryFromPlaid} - ${subCategory}`
              : categoryFromPlaid;
            if (!accumulator[key]) {
              accumulator[key] = {
                categoryName: categoryFromPlaid,
                subCategory: subCategory,
                total: 0,
              };
            }
            accumulator[key].total += amount;
          }
          return accumulator;
        }, {});

        const resultArray = Object.values(transactionsByCategory);
        console.log("resultArray", resultArray);
        setTransactions(resultArray);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const handleInputChnage = (name, value) => {
    if (name === "category") {
      console.log("value", value);
      if (value.includes("-")) {
        const [subcategoryName, categoryName] = value
          .split("-")
          .map((item) => item.trim());
        console.log("Subcategory Name:", subcategoryName);
        console.log("Category Name:", categoryName);

        // Find category and subcategory IDs
        let categoryId = null;
        let subcategoryId = null;
        categories &&
          categories.forEach((category) => {
            if (category.categoryName === categoryName) {
              categoryId = category.id;
              const subcategory =
                category.subCategories &&
                category.subCategories.find(
                  (sub) => sub.name === subcategoryName
                );
              if (subcategory) {
                subcategoryId = subcategory.id;
              }
            }
          });

        console.log("Category ID:", categoryId);
        console.log("Subcategory ID:", subcategoryId);
        setFormData({
          ...formData,
          ["categoryName"]: subcategoryName,
          ["categoryId"]: categoryId,
          ["subCategoryId"]: subcategoryId,
          ["subCategory"]: subcategoryName,
        });
      } else {
        let categoryId = null;
        categoryId =
          categories &&
          categories.find((item) => item.categoryName === value).id;
        setFormData({
          ...formData,
          ["categoryName"]: value,
          ["categoryId"]: categoryId,
          ["subCategoryId"]: null,
          ["subCategory"]: null,
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };
  const tags = [
    "This Month",
    "Last Month",
    "Last Three Month",
    "Last Six Month",
    "This Year",
    "Last Year",
    // "All Time",
  ];
  const handleApplyFilter = async (filter) => {
    console.log("Filter Data before filtering:", filter);
    console.log("payload", filter);
    console.log("filter", filterData);
    const date = moment();
    let startDate = null;
    let endDate = null;
    switch (filter) {
      case "This Month":
        startDate = date.startOf("month").format("YYYY-MM-DD"); // Start of the current month
        endDate = date.endOf("month").format("YYYY-MM-DD"); // End of the current month
        break;

      case "Last Month":
        startDate = date
          .clone()
          .subtract(1, "month")
          .startOf("month")
          .format("YYYY-MM-DD"); // Start of last month
        endDate = date
          .clone()
          .subtract(1, "month")
          .endOf("month")
          .format("YYYY-MM-DD"); // End of last month
        break;

      case "Last Three Month":
        startDate = date
          .clone()
          .subtract(2, "months")
          .startOf("month")
          .format("YYYY-MM-DD"); // Start of 3 months ago
        endDate = date.endOf("month").format("YYYY-MM-DD"); // End of the current month
        break;

      case "Last Six Month":
        startDate = date
          .clone()
          .subtract(5, "months")
          .startOf("month")
          .format("YYYY-MM-DD"); // Start of 6 months ago
        endDate = date.endOf("month").format("YYYY-MM-DD"); // End of the current month
        break;

      case "This Year":
        startDate = date.startOf("year").format("YYYY-MM-DD"); // Start of the current year
        endDate = date.endOf("year").format("YYYY-MM-DD"); // End of the current year
        break;

      case "Last Year":
        startDate = date
          .clone()
          .subtract(1, "year")
          .startOf("year")
          .format("YYYY-MM-DD"); // Start of last year
        endDate = date
          .clone()
          .subtract(1, "year")
          .endOf("year")
          .format("YYYY-MM-DD"); // End of last year
        break;

      case "All Time":
        startDate = null; // No start date for "All Time"
        endDate = null; // No end date for "All Time"
        break;

      default:
        startDate = date.startOf("month").format("YYYY-MM-DD"); // Default to start of current month
        endDate = date.endOf("month").format("YYYY-MM-DD"); // Default to end of current month
        break;
    }

    console.log("startDate:", startDate, endDate, filter);
    await getAllFilterBudgets(startDate, endDate);
    await getAllFilterBudgetsMonthsCategory(startDate, endDate);
    await getTransactionsCategoriesByFilter(startDate, endDate);
    await getTransactionsSubCategoriesByFilter(startDate, endDate);
    // let categoryIds = budgetData && budgetData.map((item) => item.categoryId);
    // if (filter && categoryArray && categoryArray.length > 0) {
    //   try {
    //     let payload = {
    //       timePeriod: filter,
    //       categoryIds: categoryArray,
    //     };
    //     console.log("payload", payload, filter);
    //     setLoading(true);
    //     let data = await DEATH_API.filterBudgets(payload);
    //     if (
    //       data &&
    //       data.status === 200 &&
    //       data.filteredBudgets &&
    //       data.filteredBudgets.length > 0
    //     ) {
    //       swal("Success", data.message, "success");
    //       setBudgetData(data.filteredBudgets);
    //       // await getCalculatedBudget();
    //     }
    //     if (data && data.status === 400) {
    //       swal("Error", data.message, "error");
    //     }
    //     setLoading(false);
    //   } catch (error) {
    //     console.log(error);
    //     setLoading(false);
    //   }
    // } else {
    //   await getBudget();
    // }
  };
  const sortData = (sortBy) => {
    let sortedData;
    switch (sortBy) {
      case "category":
        sortedData =
          budgetData &&
          [...budgetData].sort((a, b) => {
            if (
              a.budgetCategory &&
              a.budgetCategory.categoryName &&
              b.budgetCategory &&
              b.budgetCategory.categoryName
            ) {
              return a.budgetCategory.categoryName.localeCompare(
                b.budgetCategory.categoryName
              );
            } else {
              return 0; // No sorting if category name is missing
            }
          });
        break;
      case "amountLowToHigh":
        sortedData =
          budgetData &&
          [...budgetData].sort((a, b) => {
            if (a.amount !== undefined && b.amount !== undefined) {
              return a.amount - b.amount;
            } else {
              return 0; // No sorting if amount is missing
            }
          });
        break;
      case "amountHighToLow":
        sortedData =
          budgetData &&
          [...budgetData].sort((a, b) => {
            if (a.amount !== undefined && b.amount !== undefined) {
              return b.amount - a.amount;
            } else {
              return 0; // No sorting if amount is missing
            }
          });
        break;
      default:
        sortedData = budgetData && [...budgetData];
    }
    setBudgetData(sortedData);
  };

  useEffect(() => {
    getAll();
  }, []);
  const getTotalMonths = async () => {
    await getAllBudgets();
    await getAllBudgetsMonthsCategory();
  };
  const getAll = async () => {
    await getAllBudgets();
    // await getAllBudgetsUncategorized();
    await getAllBudgetsMonthsCategory();
    await getCategories();
    // await getBudget();
    let categoryIds = await getTransactionsCategories();
    let subCategoryIds = await getTransactionsSubCategories();
    let payload = {
      categoryIds,
      subCategoryIds,
    };
    await getChartDataForLast12Months(payload);
    // await getChartData();
    // await getTransactions();
  };
  const Tabs = [
    {
      id: 1,
      name: "Set Budget",
      component: (
        <SetBudget
          transactions={transactions && transactions}
          budgetData={budgetData && budgetData}
          setAddModal={setAddModal}
          setFormData={setFormData}
          setSelectedData={setSelectedData}
          categoryBudget={categoryBudget && categoryBudget}
          filterData={filterData && filterData}
          deleteSelectBudget={deleteSelectBudget}
          clientTransactionsCategories={
            clientTransactionsCategories && clientTransactionsCategories
          }
          clientTransactionsSubCategories={
            clientTransactionsSubCategories && clientTransactionsSubCategories
          }
          categories={categories && categories}
          updateTransactionsCategories={updateTransactionsCategories}
          updateTransactionsSubCategories={updateTransactionsSubCategories}
          chartData={chartData && chartData}
          loading={loading}
          getChartData={getChartDataForLast12Months}
          getAll={getTotalMonths}
        />
      ),
    },
    {
      id: 2,
      name: "Budget Categories",
      component: (
        <CategorizedBudget
          transactions={transactions && transactions}
          budgetData={budgetData && budgetData}
          monthsBudgetData={monthsBudgetData && monthsBudgetData}
          setAddModal={setAddModal}
          setFormData={setFormData}
          setSelectedData={setSelectedData}
          categoryBudget={categoryBudget && categoryBudget}
          filterData={filterData && filterData}
          deleteSelectBudget={deleteSelectBudget}
          notYetBudgetedData={notYetBudgetedData && notYetBudgetedData}
          setSelectedDataNotBudgeted={setSelectedDataNotBudgeted}
          notYetBudgetedSubcategoryData={notYetBudgetedSubcategoryData}
          loading={loading}
        />
      ),
    },
  ];

  const userRole = localStorage.getItem('role') &&  JSON.parse(localStorage.getItem('role')) !== "Financial Advisor Client"

  return (
    <div className="addBudgetMain" style={{ position: "relative" }}>
      <div className="addbudgetSection">
        <div className="addTitle">
          Budget{" "}
          <span>
            <Dropdown
              trigger={["click"]}
              overlay={
                <Menu>
                  <Menu.Item>
                    <div
                      onClick={() => {
                        history.push("/budget");
                      }}
                    >
                      Dashboard
                    </div>
                  </Menu.Item>
                  {(!financialAccess || !financialAccess.hideTransactions) && (
                    <Menu.Item>
                      <div
                        onClick={() => {
                          history.push("/budget/add/transaction");
                        }}
                      >
                        Transactions
                      </div>
                    </Menu.Item>
                  )}
                  <Menu.Item>
                    <div
                      onClick={() => {
                        history.push("/budget/add/budget");
                      }}
                    >
                      Budget
                    </div>
                  </Menu.Item>
                  {(!financialAccess || !financialAccess.hideTransactions) && (
                    <Menu.Item
                    // style={{ cursor: "not-allowed", opacity: "0.7" }}
                    >
                      <div
                        onClick={() => {
                          history.push("/budget/transaction/recurring");
                        }}
                      >
                        Recurring
                      </div>
                    </Menu.Item>
                  )}
                </Menu>
              }
            >
              <a
                className="ant-dropdown-link"
                onClick={(e) => e.preventDefault()}
              >
                <img src={editIcon} height={12} width={18} alt="icon"></img>
              </a>
            </Dropdown>
          </span>{" "}
        </div>
        <div className="budgetcreate" style={{ gap: "1rem" }}>
          <div className="filterIcons">
            <Select
              suffixIcon={
                <img src={calanderIcon} height={16} width={17} alt="icon"></img>
              }
              showSearch
              style={{ width: 200, outline: "none", border: "none" }}
              value={filterData ? filterData : "This Month"}
              placeholder="Select Filter"
              onChange={(value, id) => {
                console.log("value", value);
                setFilterData(value);
                handleApplyFilter(value);
              }}
            >
              {tags &&
                tags.map((item, index) => (
                  <Option key={index} value={item}>
                    {item}
                  </Option>
                ))}
            </Select>
          </div>
          <div className="filterIcons">
            <Dropdown
              trigger={["click"]}
              overlay={
                <Menu>
                  <Menu.Item>
                    <div
                      onClick={() => {
                        sortData("category");
                      }}
                    >
                      Category
                    </div>
                  </Menu.Item>
                  <Menu.Item>
                    <div
                      onClick={() => {
                        sortData("amountLowToHigh");
                      }}
                    >
                      Low to High
                    </div>
                  </Menu.Item>
                  <Menu.Item>
                    <div
                      onClick={() => {
                        sortData("amountHighToLow");
                      }}
                    >
                      High to Low
                    </div>
                  </Menu.Item>
                </Menu>
              }
            >
              <a
                className="ant-dropdown-link"
                onClick={(e) => e.preventDefault()}
              >
                <img src={filterIcon} height={24} width={24} alt="icon"></img>
              </a>
            </Dropdown>{" "}
          </div>
          {(!financialAccess || !financialAccess.hideTransactions) && (
            <>
            <button
            className="addbuttonassets"
            onClick={() => {
              setCategoryModal(true);
            }}
          >
            {" "}
            + Add Category
          </button>
          <button
            className="addbuttonassets"
            onClick={() => {
              setAddModal(true);
            }}
          >
            {" "}
            + Add Budget
          </button>
          </>
          )}
        </div>
      </div>

      <div className="TabSection">
        <Tab onTabSelected={onTabSelected}>
          {Tabs.map((tab, index) => (
            <TabItem key={tab.id}>{tab.name}</TabItem>
          ))}
        </Tab>
      </div>
      <div className="ComponentSection">{Tabs[selectedIndex].component}</div>
      <BudgetModal
        title={selectedData ? "Update Budget" : "Add Budget"}
        open={addModal}
        handleChange={handleInputChnage}
        handleCancel={handleCancelAddModal}
        data={formData && formData}
        handleSave={handleSaveAddModal}
        categories={categories && categories}
      />
      {categoryModal && (
        <Modal
          visible={categoryModal}
          footer={null}
          onOk={handleCancelCategory}
          onCancel={handleCancelCategory}
          closable={false}
          centered
        >
          <h3 className="modaltitle">Add Category</h3>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Create under a Primary Category</h3>
            {/*   <Select
            showSearch
            placeholder="-Select-"
            // value={formData && formData.categoryName}
            onChange={(value, id) => {
              console.log("value", value);
              // handleChange("categoryName", value);
            }}
          >
            {categories && categories.map(category => (
              <OptGroup key={category.id} label={category.categoryName} title={category.categoryName}>
              <Option  key={category.id} value={category.categoryName}> {category.categoryName}</Option>
                {category.subCategories.map((subCategory, index) => (
                  <Option key={`${category.id}-${index}`} value={subCategory.name}>
                    {subCategory.name}
                  </Option>
                ))}
              </OptGroup>
            ))}
          </Select> */}
            <TreeSelect
              showSearch
              dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
              placeholder="Choose Primary Category"
              allowClear
              // treeDefaultExpandAll
              value={formData && formData.categoryName}
              onChange={(value, id) => {
                console.log("value", value);
                handleInputChnage("categoryName", value);
              }}
            >
              {categories &&
                categories.map((category) => (
                  <TreeNode
                    key={category.id}
                    value={category.categoryName}
                    title={category.categoryName}
                  >
                    {category.subCategories.map((subCategory, index) => (
                      <TreeNode
                        disabled
                        key={`${category.id}-${index}`}
                        value={subCategory.name}
                        title={subCategory.name}
                      />
                    ))}
                  </TreeNode>
                ))}
            </TreeSelect>
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">New Category</h3>

            <input
              className="roleInput"
              placeholder="Category"
              name="subCategoryName"
              value={formData && formData.subCategoryName}
              id="categoryName"
              onChange={(e) => {
                e.preventDefault();
                handleInputChnage(e.target.name, e.target.value);
              }}
            />
          </div>

          <div className="buttonsMain">
            <button
              className="cancelbutton"
              onClick={() => {
                handleCancelCategory();
              }}
            >
              Cancel
            </button>
            <button
              className="savebutton"
              disabled={!formData || !formData.subCategoryName}
              onClick={() => {
                handleSaveCategory();
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}
      {/*<NewLoader isLoading={loading} /> */}
      {/* <Loader isLoading={loading} />*/}
    </div>
  );
};
